<template>
  <div class="container">
    <div
      :class="[
        'panel',
        { 'panel--profile': itemType === 'profile' },
        { 'panel--scroll': itemType !== 'profile' },
      ]"
    >
      <template v-if="itemType != 'profile'">
        <vue-scroll :ops="ops">
          <div class="title">{{ title }}</div>
          <div
            class="list"
            v-for="option in options"
            :key="option.optionId"
            :class="isCheck(option.optionId, 'checkedOption')"
          >
            <div
              :class="[
                'element',
                {
                  selected:
                    itemType === focusType && locFocus.y === option.optionId,
                },
              ]"
              @mouseover="onMouseOver()"
              @click="saveElement(itemType, option.optionId)"
            >
              <div class="card">
                <div
                  v-if="itemType === 'age'"
                  class="text"
                  :class="isCheck(option.optionId, 'checkedText')"
                >
                  {{ getLabel(option.display) }} 
                </div>
                <div
                  v-else
                  class="text"
                  :class="isCheck(option.optionId, 'checkedText')"
                >
                  {{ option.display }}              
                </div>
                <div :class="isCheck(option.optionId, 'checked')"></div>
              </div>
            </div>
          </div>
        </vue-scroll>
      </template>
      <template v-else>
        <div class="inner">
          <div class="title-image">
            <img src="@/assets/icons/devices.svg" alt="Account" />
          </div>
          <div class="title acc">
            {{
              getUserName 
                ? getUserName
                : strings.registerforFree 
            }}
          </div>
          <div class="account-button" v-if="getUserName">
            <span v-if="getUserToken" class="acc-btn" @click="goToAccount('/')">
              {{ strings.viewAccount }}
            </span>
          </div>

          <div class="account-button" v-if="!getUserName">
            <span class="acc-btn green" @click="goToAccount('/register')">
              {{ strings.register }}
            </span>
            <span class="small-link" @click="goToAccount('/login')">
              {{ strings.toLogin }}
            </span>
          </div>
        </div>
      </template>
    </div>
  </div>
</template>

<script>
import { soundList, soundPlayer } from "../utils/sounds";
import { executeOnTV } from "../utils/utils";
import SettingStorage, {
  storageLabels,
  settingStorageJson,
} from "@/utils/settings.storage";
import { itemList, othersOptions, OtherTypes } from "../utils/settings.options";
import { toggleFullScreen } from "../utils/settings.fullscreen";
import LoopSong from "@/utils/sounds";
import userService from "@/services/user.service";
import langUtil, { StringKey } from "@/utils/lang.util";

export default {
  props: {
    title: {
      type: String,
    },
    options: {
      type: Array,
    },
    itemType: {
      type: String,
    },
  },
  data() {
    return {
      ops: {
        vuescroll: {
          mode: "slide",
          zooming: false,
          locking: true,
          scroller: {
            bouncing: false,
          },
        },
        scrollPanel: {
          scrollingX: false,
          scrollingY: true,
        },
        bar: {
          onlyShowBarOnScroll: true,
          keepShow: false,
          background: "#d7d7d7",
        },
      },
      activeClass: false,
      selectedElement: 0,
      storedItemType: "",
      locFocus: { x: 0, y: 1 },
      focusType: "age",
      operaTv: false,
      strings: {
        registerforFree: langUtil.getLang().t(StringKey.registerforFree),
        viewAccount: langUtil.getLang().t(StringKey.SettingsViewAccount),
        register: langUtil.getLang().t(StringKey.SettingsRegister),
        toLogin: langUtil.getLang().t(StringKey.SettingsToLogin),
      },
    };
  },
  computed: {
    settings() {
      return this.$store.state.settings;
    },
    getContentType() {
      return this.$store.getters["settings/getContentType"];
    },
    getTime() {
      return this.$store.getters["settings/getTime"];
    },
    timeIsSet() {
      return this.$store.getters["settings/timeIsSet"];
    },
    soundActive() {
      return this.$store.getters["settings/soundActive"];
    },
    getUserToken() {
      return this.$store.getters["account/getToken"];
    },
    getUserName() {
      return this.$store.getters["account/getUserName"];
    },
    getPremium() {
      return this.$store.getters["account/getPremium"];
    },
    hasPartnerAccess() {
      return this.getUserToken === false && this.getPremium === true;
    },
    getPartnerToken() {
      return this.$store.getters["account/getPartnerToken"];
    },
    getter() {
      return this.$store.getters["settings/getSettingsCloseBtnState"];
    },
  },
  methods: {
    getLabel(value) {
      return langUtil.getLang().t(value);
    },
    getUserGenerateKey() {
      return this.$store.dispatch('account/getUserGenerateKey');
    },
    setType(type) {
      this.$store.dispatch("settings/setType", type);
    },
    setTimeLimit(limit) {
      this.$store.dispatch("settings/setTimeLimit", limit);
    },
    setTimeVariable(val) {
      this.$store.dispatch("settings/setTimeVariable", val);
    },
    setAge(val) {
      this.$store.dispatch("settings/setAge", val);
    },
    setLanguage(val) {
      this.$store.dispatch("settings/setLanguage", val);
    },
    setSound(val) {
      this.$store.dispatch("settings/setSound", val);
    },
    setFocusSettings(val) {
      this.$store.dispatch("settings/setFocusSettings", val);
    },
    setActiveSettingsCloseBtn(val) {
      this.$store.dispatch("settings/setActiveSettingsCloseBtn", val);
    },
    async goToAccount(path) {
      if (path === '/register' || path === '/login') {
        window.location.href =
        process.env.VUE_APP_ACCOUNT_BASE_URL + path + '?app=tv';
      } else {
        await this.getUserGenerateKey().then((response) => {
          if (response.status === 200) {
            this.$store.dispatch('account/resetUserToken');
            window.location.href =
            process.env.VUE_APP_ACCOUNT_BASE_URL + path +
              '?key=' +
              response.data.redirectKey;
          }
          }).catch((error) => {
            window.location.href = process.env.VUE_APP_ACCOUNT_BASE_URL + path;
          });
      }
    },
    isCheck(optionId, className) {
      let isChecked = false;

      if (
        optionId === this.selectedElement &&
        this.itemType === this.storedItemType
      ) {
        isChecked = true;
      } else {
        isChecked = false;
      }

      const obj = {};
      obj[className] = isChecked;
      return obj;
    },
    saveElement(itemT, optionId) {
      soundPlayer(soundList.general);
      if (itemT !== itemList.other || optionId === 0) {
        this.selectedElement = optionId;
      }
      this.storedItemType = itemT;
      this.activeClass = true;
      const typeExist = SettingStorage.findItemType(itemT);

      let addToLocalStorage = false;
      if (itemT === itemList.other) {
        const otherOptionValueSelected = othersOptions.find((x) => {
          return x.optionId === optionId;
        });

        const otherValueSelected = otherOptionValueSelected.value;
        if (otherValueSelected === OtherTypes.sound) {
          SettingStorage.toogleSound();
          if (this.soundActive) {
            this.selectedElement = 0;
            this.setSound(false);
            LoopSong.pause();
          } else {
            this.selectedElement = 1;
            this.setSound(true);
            LoopSong.play();
          }
        } else if (otherValueSelected === OtherTypes.fullscreen) {
          toggleFullScreen();
        } else if (otherValueSelected === OtherTypes.link) {
          this.goToAccount('/');
        } else if (otherValueSelected === OtherTypes.legal) {
          window.location.href = "https://www.kidjo.tv/privacy";
        } else if (otherValueSelected === OtherTypes.unsubscribe) {
          try {
            if (VK_0) {
              window.location.href =
                process.env.VUE_APP_ACCOUNT_BASE_URL + "/vewd/unsubscribe";
            }
          } catch (error) {
            window.location.href =
              process.env.VUE_APP_ACCOUNT_BASE_URL + "/info";
          }
        }
      } else {
        addToLocalStorage = true;
      }

      if (addToLocalStorage) {
        this.selectedElement = optionId;
        if (typeExist !== false) {
          settingStorageJson[typeExist].item.option = optionId;
        } else {
          settingStorageJson.push({
            item: { type: this.itemType, option: optionId },
          });
        }
        localStorage.setItem(
          storageLabels.settingStorage,
          JSON.stringify({ settingStorageJson })
        );
      }

      // Setting language for the app
      if (itemT === itemList.language) {
        userService.updateLanguage(
          SettingStorage.getOptionValue(itemList.language).value
        );
      }

      // Adding to Store
      if (itemT === itemList.content) {
        this.setType(SettingStorage.getOptionValue(itemList.content));
      } else if (itemT === itemList.time) {
        this.setTimeLimit(SettingStorage.getOptionValue(itemList.time) * 60);
        this.setTimeVariable(true);
      } else if (itemT === itemList.age) {
        this.setAge(SettingStorage.getOptionValue(itemList.age));
      } else if (itemT === itemList.language) {
        this.setLanguage(
          SettingStorage.getOptionValue(itemList.language).value
        );
      }

      // Analytics
      const optionValue = SettingStorage.getOptionValue(itemT);
      const analyticsValue =
        itemT === itemList.language
          ? optionValue.codeLang
          : itemT === itemList.time && optionValue === -1
          ? "nolimit"
          : optionValue;
      const analyticsKey =
        itemT === itemList.language
          ? "language"
          : itemT === itemList.age
          ? "kidsAge"
          : itemT === itemList.time
          ? "videoTimeLimit"
          : itemT === itemList.content
          ? "videoProgram"
          : null;
      if (analyticsKey !== null) {
        this.$ga.event("settings", analyticsKey, analyticsValue);
      }
    },
    onTv() {
      this.focusType = this.reverseItemType(this.locFocus.x);
      this.operaTv = true;
    },
    notOnTv() {
      this.focusType = "";
      this.operaTv = false;
    },
    changePanelHeight() {
      const panels = document.getElementsByClassName("panel");
      let max = 0;

      for (let i = panels.length - 1; i >= 0; i -= 1) {
        if (panels[i] && panels[i].offsetHeight > max) {
          max = panels[i].offsetHeight;
        }
      }

      for (let x = panels.length - 1; x >= 0; x -= 1) {
        panels[x].style.height = max - 5 + "px";
      }
    },
    onMouseOver() {
      this.focusType = "";
    },
    handleKeydown(event) {
      event.preventDefault();
    },
    handleKeyboard(event) {
      event.preventDefault();
      const x = this.convertItemType(this.itemType);

      try {
        switch (event.keyCode) {
          case VK_ENTER: {
            if (this.getSettingsCloseBtnState) {
              this.closeSettings();
            } else if (x === this.locFocus.x) {
              this.saveElement(this.itemType, this.locFocus.y);
            }
            break;
          }
          case VK_UP: {
            this.changeCoordY(this.locFocus.x, this.locFocus.y, "less");
            break;
          }
          case VK_DOWN: {
            this.changeCoordY(this.locFocus.x, this.locFocus.y, "more");
            break;
          }
          case VK_LEFT: {
            if (this.locFocus.x > 0) {
              this.locFocus.x--;
              this.focusType = this.reverseItemType(this.locFocus.x);
              if (this.locFocus.x === 1) {
                this.locFocus.y = 0;
              } else {
                this.locFocus.y = 1;
              }
            }
            break;
          }
          case VK_RIGHT: {
            if (this.locFocus.x < 4) {
              this.locFocus.x++;
              this.focusType = this.reverseItemType(this.locFocus.x);
              if (this.locFocus.x === 1) {
                this.locFocus.y = 0;
              } else {
                this.locFocus.y = 1;
              }
            }
            break;
          }
          case VK_BACK:
          case VK_BACK_SPACE: {
            this.setFocusSettings(false);
            break;
          }
        }
      } catch (error) {
        switch (event.code) {
          case "Enter": {
            if (this.getSettingsCloseBtnState) {
              this.closeSettings();
            } else if (x === this.locFocus.x) {
              this.saveElement(this.itemType, this.locFocus.y);
            }
            break;
          }
          case "ArrowLeft": {
            if (this.locFocus.x > 0) {
              this.locFocus.x--;
              this.focusType = this.reverseItemType(this.locFocus.x);
              if (this.locFocus.x === 1) {
                this.locFocus.y = 0;
              } else {
                this.locFocus.y = 1;
              }
            }
            break;
          }
          case "ArrowRight": {
            if (this.locFocus.x < 4) {
              this.locFocus.x++;
              this.focusType = this.reverseItemType(this.locFocus.x);
              if (this.locFocus.x === 1) {
                this.locFocus.y = 0;
              } else {
                this.locFocus.y = 1;
              }
            }
            break;
          }
          case "ArrowUp": {
            this.changeCoordY(this.locFocus.x, this.locFocus.y, "less");
            break;
          }
          case "ArrowDown": {
            this.changeCoordY(this.locFocus.x, this.locFocus.y, "more");
            break;
          }
        }
        // this.focusType = '';
      }
    },
    closeSettings() {
      soundPlayer(soundList.general);
      this.$router.go(-1);
    },
    convertItemType(iType) {
      if (iType === "age") {
        return 0;
      }

      if (iType === "time") {
        return 1;
      }

      if (iType === "content") {
        return 2;
      }

      if (iType === "language") {
        return 3;
      }

      if (iType === "other") {
        return 4;
      }

      return -1;
    },
    reverseItemType(num) {
      if (num === 0) {
        return "age";
      }

      if (num === 1) {
        return "time";
      }

      if (num === 2) {
        return "content";
      }

      if (num === 3) {
        return "language";
      }

      if (num === 4) {
        return "other";
      }

      return "";
    },
    changeCoordY(x, y, sens) {
      if (!this.getSettingsCloseBtnState) {
        if (sens === "less") {
          if (x === 1) {
            if (this.locFocus.y > 0) {
              this.locFocus.y--;
            }
          } else {
            if (this.locFocus.y > 1) {
              this.locFocus.y--;
            } else {
              this.setActiveSettingsCloseBtn(true);
            }
          }
        } else {
          if (x === 2 && this.locFocus.y < 3) {
            this.locFocus.y++;
          } else if (x === 0 && this.locFocus.y < 7) {
            this.locFocus.y++;
          } else if (x === 1 && this.locFocus.y < 5) {
            this.locFocus.y++;
          } else if (x === 3 && this.locFocus.y < 8) {
            this.locFocus.y++;
          } else if (x === 4 && this.locFocus.y < 4) {
            this.locFocus.y++;
          }
        }
      } else if (sens === "more") {
        this.setActiveSettingsCloseBtn(false);
      }
    },
  },
  mounted() {
    this.setFocusSettings(false);
    const itemType = SettingStorage.findItemType(this.itemType);

    document.addEventListener("keydown", this.handleKeydown);
    document.addEventListener("keyup", this.handleKeyboard);
    executeOnTV(this.onTv, this.notOnTv);

    if (itemList.other === this.itemType) {
      this.storedItemType = this.itemType;
      if (SettingStorage.findItemType(this.itemType) === false) {
        settingStorageJson.push({
          item: { type: this.itemType, option: 1, play: true },
        });
        localStorage.setItem(
          storageLabels.settingStorage,
          JSON.stringify({ settingStorageJson })
        );
        this.selectedElement = 1;
      } else {
        if (SettingStorage.playSound()) {
          this.selectedElement = 1;
        }
      }
    } else {
      if (settingStorageJson.length > 0 && itemType !== false) {
        this.storedItemType = this.itemType;
        this.selectedElement = SettingStorage.getSelectedOption(this.itemType);
      }
    }
  },
  destroyed() {
    document.removeEventListener("keydown", this.handleKeydown);
    document.removeEventListener("keyup", this.handleKeyboard);
  },
};
</script>

<style lang="scss" scoped>
@import "../assets/styles/breakpoints.scss";

.container {
  min-width: 230px;
  max-width: 300px;
  // margin: 10px;
  font-family: "Nunito-ExtraBold", serif;

  @media (orientation: portrait) {
    width: 280px;
    min-height: 380px;
    max-height: 380px;
  }

  @media (orientation: landscape) {
    flex: 0 0 18%;
    height: 100%;
    max-height: 400px;
  }

  @media (min-width: $breakpoint-lg) {
    flex: 0 0 33%;
    max-width: 340px;
  }

  & * {
    box-sizing: border-box;
  }

  .panel {
    display: flex;
    flex-direction: column;
    height: 100%;
    background-color: #fff;
    border: 4px solid #6d4c41;
    border-radius: 18px;

    &--profile {
      justify-content: center;

      .inner {
        flex: initial;
        margin: 0;
      }
    }

    &--scroll {
      padding: 3px 6px;
    }

    @media (max-width: $breakpoint-xs) {
      border-width: 3px;
      border-radius: 10px;
    }

    .title-image {
      width: 100%;
      text-align: center;

      @media (max-width: $breakpoint-xs) {
        padding-top: 0;
      }

      img {
        width: 80%;
        max-width: 250px;

        @media (max-width: $breakpoint-xs) {
          width: 61%;
          padding-top: 0;
        }

        @media (orientation: landscape) and (max-height: $breakpoint-sm) {
          width: 50%;
        }
      }
    }

    .account-button {
      text-align: center;
      margin-top: 15px;
      margin-bottom: 5px;

      @media (max-width: 768px) {
        margin-bottom: 25px;
      }

      @media (max-width: 768px) {
        margin-bottom: 0;
        margin-top: 0;
      }

      @media (orientation: landscape) and (max-height: 620px) {
        margin: 10px 0;
      }

      .acc-btn {
        display: inline-block;
        font-family: "Nunito-ExtraBold";
        font-size: 17px;
        color: #ffffff;
        padding: 10px 20px;
        border: 3px solid #6d4c41;
        border-radius: 15px;
        background-color: #fda536;
        cursor: pointer;

        @media (min-width: 900px) {
          width: 80%;
          font-size: 24px;
          margin-bottom: 10px;
        }

        @media (max-width: 480px) {
          width: 73%;
          font-size: 20px;
          border-radius: 10px;
          padding: 7px 20px;
        }

        @media (orientation: landscape) and (max-height: 620px) {
          width: 70%;
          font-size: 16px;
        }

        &.green {
          background-color: #8bc34a;
        }
        &:hover,
        &:focus {
          transform: scale(1.1);
        }
      }

      .small-link {
        font-family: "Nunito-ExtraBold";
        font-size: 18px;
        color: #6d4c41;
        text-decoration: underline;
        display: block;
        margin-top: 10px;
        cursor: pointer;

        @media (orientation: landscape) and (max-height: 620px) {
          font-size: 16px;
        }

        &:hover,
        &:focus {
          color: #fda536;
        }
      }
    }
  }

  .inner {
    flex: 1;
    margin: 12px;
    display: flex;
    flex-direction: column;
  }

  .title {
    margin-top: 8px;
    color: #6d4c41;
    font-size: 18px;
    text-align: center;
    margin-bottom: 10px;

    &.acc {
      padding: 0 10px;
      margin-bottom: 0;

      @media (min-width: $breakpoint-lg) {
        font-size: 22px;
      }
    }
  }

  .list {
    flex-direction: column;
    margin-top: 2px;
    margin-bottom: 2px;
    padding-left: 4px;
    padding-right: 4px;

    .element {
      padding: 0 10px;
      border: 2px solid white;
      border-radius: 16px;

      &:hover {
        padding: 0 10px;
        border-color: #6d4c41;
      }
    }

    &.checkedOption {
      padding: 5px;

      .element {
        padding: 0 10px;
        color: #fff;
        background-color: #fda536;
        border: 2px solid #6d4c41;
        border-radius: 16px;
      }
    }
  }

  .card {
    display: flex;
    position: relative;
    height: 30px;
  }

  .text {
    text-align: center;
    font-size: 18px;
    margin: auto;
  }

  .checked {
    width: 15px;
    height: 15px;
    right: 4px;
    align-self: center;
    position: absolute;
    background-image: url("~@/assets/icons/check.svg");
    background-position: center;
    background-size: contain;
    background-repeat: no-repeat;

    @media (min-width: $breakpoint-md) {
      width: 24px;
      height: 24px;
      right: 0;
    }
  }

  .checkedText {
    color: #fff;
    line-height: 1;
  }

  .settings-link {
    color: #6d4c41;
    text-decoration: none;
  }
}
</style>
